import React from "react";
import {
  Menu,
  MenuItem,
  MenuLabel,
  MenuSeparator,
} from "../../components/Menu";
import { currentUserAtom } from "../../jotai/atoms";
import { useAtom } from "jotai";
import { styled } from "../../stitches.config";
import Icon from "../../components/Icon";
import { useSpaceInfo, useUserInfos } from "../../roomservice/maps";
import {
  EditNameDialog,
  EditColorDialog,
  EditNameDialogTrigger,
  EditColorDialogTrigger,
} from "./EditUser";

export default function BuddyList() {
  const [currentUser] = useAtom(currentUserAtom);
  const userInfos = useUserInfos();
  const [info] = useSpaceInfo();

  return (
    <>
      <Menu
        icon="People"
        label={`${Object.keys(userInfos).length}`}
        ariaLabel={`Buddy list (${Object.keys(userInfos).length} online)`}
      >
        <MenuLabel>Buddy List</MenuLabel>

        {Object.values(userInfos).map((userInfo) => {
          return (
            <MenuItem as={Buddy} key={userInfo.id}>
              <Dot style={{ background: userInfo.color }} />
              {userInfo.name}
              {currentUser?.id === userInfo.id && ` (me)`}
              <div>
                {userInfo?.video ? <Icon icon="CamOn" color="black" /> : null}
                {userInfo?.audio ? <Icon icon="MicOn" color="black" /> : null}
              </div>
              {info?.owners?.includes(userInfo.id) && <Label>Host</Label>}
            </MenuItem>
          );
        })}

        <MenuSeparator />
        <EditNameDialogTrigger />
        <EditColorDialogTrigger />
      </Menu>
      <EditNameDialog />
      <EditColorDialog />
    </>
  );
}

const Buddy = styled("li", {
  display: "grid",
  gridTemplateColumns: "auto 1fr auto 1fr",
  gridGap: "$1",
  alignItems: "center",
  padding: "$2",
});

const Dot = styled("div", {
  width: "$2",
  height: "$2",
  borderRadius: "$circle",
});

const Label = styled("div", {
  justifySelf: "end",
  color: "$menuTitleGray",
});
